import { Modal, Space } from "antd";

export const AdminToolCommonModal = (props) => {
  const { body, modalIcon } = props;

  return (
    <Modal {...props} footer={null} closeIcon={null} centered className={`${props?.className}`}>
      <Space direction="vertical">
        {modalIcon && (
          <div className="d-flex justify-content-between align-items-start">
            <span>{modalIcon}</span>
          </div>
        )}
        {body}
      </Space>
    </Modal>
  );
};
